/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Notes/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Notes({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Receivables/Content/Transactions/Content/Content/Transaction/EntityType/Payment/PaymentMethod/BankAccountPayment/Notes"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let entryAppliedPaymentPaymentNotesValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'applied_payment.payment.notes',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(entryAppliedPaymentPaymentNotesValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}